@let gridColumns = 'repeat(auto-fill, minmax(' + minCardWidth() + 'px, 1fr))';

<div class="flex flex-col gap-3">
  @if (loading()) {
    <div class="grid gap-4" [style.grid-template-columns]="gridColumns">
      @for (skeleton of skeletonCards; track skeleton) {
        <ngx-skeleton-loader [theme]="{ 'border-radius': '16px', height: '240px', margin: '0', width: '100%' }" />
      }
    </div>
  } @else if (cards().length === 0) {
    <div class="text-center font-bold text-shikenso-purple-base-60">
      {{ 'pages.campaignDetails.ctaAnalytics.details.findingCards.noFindings' | translate }}
    </div>
  } @else {
    <div class="flex items-center gap-4 text-xs">
      <span class="font-bold">{{ 'pages.campaignDetails.ctaAnalytics.details.findingCards.sort' | translate }}</span>
      <div
        class="flex items-center gap-4"
        role="radiogroup"
        [attr.aria-label]="'pages.campaignDetails.ctaAnalytics.details.findingCards.sort' | translate"
      >
        @for (option of sortOptions; track option.value) {
          @let checked = sortMode() === option.value;
          <button
            type="button"
            role="radio"
            class="flex items-center gap-2"
            [attr.aria-checked]="checked"
            (click)="sortMode.set(option.value)"
          >
            <mat-pseudo-checkbox [state]="checked ? 'checked' : 'unchecked'" />
            <span>{{ option.labelKey | translate }}</span>
          </button>
        }
      </div>
    </div>

    <div class="grid gap-4" [style.grid-template-columns]="gridColumns" (click)="onGridClick($event)">
      @for (card of renderedCards(); track card.id) {
        <app-finding-card
          class="block"
          [attr.data-finding-id]="card.id"
          [data]="card"
          [selected]="card.id === selectedId()"
          [dimmed]="dimmedIds().has(card.id)"
          [canLoadImage]="canLoadImages()"
          [imageCampaignExportId]="imageCampaignExportId()"
          [aspectRatio]="aspectRatio()"
          [numberColor]="numberColor()"
          (openOnPlatform)="onOpenOnPlatform($event, card)"
        >
          @if (actionsTemplate(); as actions) {
            <div findingCardActions>
              <ng-container *ngTemplateOutlet="actions; context: { $implicit: card }" />
            </div>
          }
        </app-finding-card>
      }
    </div>

    @if (hasMoreCards()) {
      <div class="h-px" #loadMoreSentinel></div>
    }
  }
</div>
